import type { IStockRepository, TransactionUpdateInput } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockTransactionEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createUpdateTransactionUseCase({ stockRepository }: Deps) {
  return async function updateTransaction(input: { id: string; data: TransactionUpdateInput }): Promise<StockTransactionEntity | null> {
    return stockRepository.updateTransaction(input.id, input.data);
  };
}
